import Vue from 'vue'
import App from './App.vue'
import './plugins/bootstrap'
import i18n from './i18n'

Vue.config.productionTip = false

// Library for beauty alerts
window.swal = require('sweetalert')

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
